import React, { Component } from "react";
import Cookies from "universal-cookie";
import moment from "moment";
import { Buffer } from "buffer";
import Spreadsheet from "react-spreadsheet";

import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";

import { stockOtodisService } from "../../services/otodisApi/StockOtodisService";

import { Button, Col, DatePicker, Form, Input, Row, Modal, Upload } from "antd";

import { SaveOutlined, ReloadOutlined, UploadOutlined } from "@ant-design/icons";

import { ImportPucrhaseStockStates } from "./types/ImportPucrhaseStockTypes";
import WarehouseSelect from "../../components/warehouse/WarehouseSelect";
import SupplierSelect from "../../components/supplier/SupplierSelect";

import SelectConfigArray from "../../components/selects/SelectConfigArray";
import { allowedOrganization, vehicleConditionList } from "../../config/data/generalConfig";
import { docUploadApiService } from "../../services/otodis/DocUploadApiService";

export interface ImportPucrhaseStockProps {}

class ImportPucrhaseStock extends Component<ImportPucrhaseStockProps & any, ImportPucrhaseStockStates> {
  private readonly initState!: ImportPucrhaseStockStates;
  private uDealer = JSON.parse(Buffer.from(new Cookies().get("_d"), "base64").toString());
  private token = new Cookies().get("_t");
  private readonly columnLabels: any;

  constructor(props: (ImportPucrhaseStockProps & any) | any) {
    super(props);

    const finalDealerCode = props.match.params.dealerCode.replace(/-/g, "#");
    const picked = this.uDealer.find((o: { DealerCode: any }) => o.DealerCode === finalDealerCode);
    const companyCode = picked?.DealerCompany ?? "AMARTA";

    const pickedOrganization: any = allowedOrganization.find((o) => o.companyId === companyCode.toUpperCase()) ?? {};

    this.initState = {
      processing: false,
      submitting: false,
      dataSheet: [
        [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
      ],

      dealerCode: finalDealerCode,
      companyCode: companyCode,
      dataOrg: pickedOrganization,

      supplierCode: null,
      warehouseCode: null,
      invoiceDate: moment().clone().format("YYYY-MM-DD"),
      invoiceNumber: "",
      deliveryDate: moment().clone().format("YYYY-MM-DD"),
      deliveryNumber: "",
      vehicleCondition: null,
      taxPercentage: 11,

      modalUploadVisible: false,
      modalUploadFile: null,

      // supplierCode: "SUP#CRY#10009701-DEFAULT",
      // warehouseCode: "WRH#CRY#10009701-DEFAULT",
      // invoiceDate: moment().clone().format("YYYY-MM-DD"),
      // invoiceNumber: "TES ADD STOCK RORA - Nomor Invoice",
      // deliveryDate: moment().clone().format("YYYY-MM-DD"),
      // deliveryNumber: "TES ADD STOCK RORA - Nomor Surat Jalan",
      // vehicleCondition: "NEW",
      // taxPercentage: 11,
    };
    this.state = { ...this.initState };
    this.columnLabels = ["Kode Variant", "Kode Warna", "Nama Warna", "No Mesin", "No Rangka", "No Polisi", "Tahun Kendaraan", "Harga Beli", "Diskon Beli", "Estimasi Harga Jual", "Nomor VIN"];
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      dealerCode: data.value,
      warehouseCode: null,
      supplierCode: null,
    });
  };

  onWarehouseChange = async (data: any) => {
    await this.promisedSetState({
      warehouseCode: data.value,
    });
  };

  onSupplierChange = (data: any) => {
    this.setState({
      supplierCode: data.value,
    });
  };

  onStringFieldChange = <T extends keyof Pick<any, "companyCode" | "deliveryDate" | "deliveryNumber" | "invoiceDate" | "invoiceNumber" | "vehicleCondition" | "taxPercentage">>(
    target: T,
    value: any
  ) => {
    const currentState: any = { ...this.state };

    switch (target) {
      case "companyCode":
        currentState.companyCode = value;
        break;
      case "deliveryDate":
        currentState.deliveryDate = value;
        break;
      case "deliveryNumber":
        currentState.deliveryNumber = value;
        break;
      case "invoiceDate":
        currentState.invoiceDate = value;
        break;
      case "invoiceNumber":
        currentState.invoiceNumber = value;
        break;
      case "vehicleCondition":
        currentState.vehicleCondition = value;
        break;
      case "taxPercentage":
        currentState.taxPercentage = value;
        break;
    }

    this.setState({
      ...currentState,
    });
  };

  onReset = async () => {
    await this.promisedSetState({
      ...this.initState,
    });
  };

  showModalUploadPdfVinfast = (visible: boolean) => {
    this.setState({ modalUploadVisible: visible, modalUploadFile: null });
  };

  onSheetChange = (newData: any) => {
    if (JSON.stringify(newData) !== JSON.stringify(this.state.dataSheet)) {
      this.setState({ dataSheet: newData });
    }
  };

  onResetSheet = () => {
    this.setState({
      dataSheet: [
        [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
        [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
      ],
    });
  };

  submitPdfVinfast = async () => {
    const { dataOrg, modalUploadFile } = this.state;

    if (!modalUploadFile) {
      Modal.error({ title: "Error", content: "Invalid File Empty" });
      return;
    }
    if (!dataOrg.companyId) {
      Modal.error({ title: "Error", content: "Invalid Company Code" });
      return;
    }
    if (!dataOrg.copanAreaCode) {
      Modal.error({ title: "Error", content: "Invalid Copan Area" });
      return;
    }
    if (!dataOrg.copanDefaultBrandUuid) {
      Modal.error({ title: "Error", content: "Invalid Brand UUID" });
      return;
    }

    this.setState({ submitting: true });

    // docUploadApiService.setToken(this.token);

    const formData = new FormData();
    formData.append("company_code", dataOrg.companyId);
    formData.append("area_code", dataOrg.copanAreaCode);
    formData.append("brand_uuid", dataOrg.copanDefaultBrandUuid);
    formData.append("document", modalUploadFile);

    try {
      await docUploadApiService.uploadInvoicePdfVinfast(formData).then(async (result: any) => {
        const resultDataTable = result.data.data?.data_table;

        const hotData = resultDataTable.map((item: any) => [
          { value: item.variant_code }, // Kode Variant
          { value: item.color_code }, // Kode Warna
          { value: item.color_name }, // Nama Warna
          { value: "" }, // No Mesin (belum tersedia di data)
          { value: "" }, // No Rangka (belum tersedia di data)
          { value: "" }, // No Polisi
          { value: moment(this.state.invoiceDate).format("YYYY") }, // Tahun Kendaraan
          { value: "" }, // Harga Beli
          { value: "" }, // Diskon Beli
          { value: "" }, // Estimasi Harga Jual
          { value: item.vin_number }, // Nomor VIN
        ]);

        await this.promisedSetState({
          submitting: false,
          warehouseCode: result.data.data?.data_table[0]?.warehouse_code || null,
          invoiceNumber: result.data.data.invoice_number,
          deliveryNumber: result.data.data.invoice_number,
          modalUploadVisible: false,
          modalUploadFile: null,
          dataSheet: hotData,
        });
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda : " + e,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  beforeUploadFile = (file: any) => {
    const isPdf = file.type === "application/pdf";
    if (!isPdf) {
      Modal.error({
        title: "Proses Gagal",
        content: "Format File Bukan PDF",
      });
    }
    if (isPdf) {
      this.setState({
        modalUploadFile: file,
      });
    } else {
      this.setState({
        modalUploadFile: [],
      });
    }
    return false;
  };

  onAddStock = async () => {
    const currentState: any = { ...this.state };

    if (currentState.vehicleCondition === "SECOND" && currentState.vehicleEngineNumber === "") {
      currentState.vehicleEngineNumber = currentState.vehicleLicensePlate;
    }

    if (!currentState.dealerCode) {
      Modal.error({ title: "Error", content: "Invalid Dealer" });
      return;
    }
    if (!currentState.companyCode) {
      Modal.error({ title: "Error", content: "Invalid Company Code" });
      return;
    }
    if (!currentState.supplierCode) {
      Modal.error({ title: "Error", content: "Supplier harus diisi" });
      return;
    }
    if (!currentState.warehouseCode) {
      Modal.error({ title: "Error", content: "Gudang harus diisi" });
      return;
    }
    if (!currentState.invoiceDate) {
      Modal.error({ title: "Error", content: "Tanggal Invoice harus diisi" });
      return;
    }
    if (!currentState.invoiceNumber) {
      Modal.error({ title: "Error", content: "Nomor Invoice harus diisi" });
      return;
    }
    if (!currentState.deliveryDate) {
      Modal.error({ title: "Error", content: "Tanggal Surat Jalan harus diisi" });
      return;
    }
    if (!currentState.deliveryNumber) {
      Modal.error({ title: "Error", content: "Nomor Surat Jalan harus diisi" });
      return;
    }
    if (!currentState.vehicleCondition) {
      Modal.error({ title: "Error", content: "Kondisi Kendaraan harus diisi" });
      return;
    }

    if (!currentState.taxPercentage || currentState.taxPercentage < 0) {
      Modal.error({ title: "Error", content: "Persentase Pajak Beli harus diisi" });
      return;
    } else if (currentState.taxPercentage > 30) {
      Modal.error({ title: "Error", content: "Persentase Pajak tidak valid" });
      return;
    }

    const dataTable = currentState.dataSheet;

    let dataCleaned = [];
    for (const row of dataTable) {
      if (row[1]?.value && row[2]?.value && row[6]?.value) {
        const dpp_beli = this.convertToNumeric(row[7]?.value) - this.convertToNumeric(row[8]?.value);
        let ppn_beli = 0;
        let hpp_beli = 0;

        if (dpp_beli > 0) {
          ppn_beli = dpp_beli * (this.convertToNumeric(currentState.taxPercentage) / 100);
          hpp_beli = dpp_beli + ppn_beli;
        }
        dataCleaned.push({
          vehicle_variant_code: row[0]?.value,
          vehicle_color_code: row[1]?.value,
          vehicle_color_name: row[2]?.value,
          vehicle_engine_number: row[3]?.value,
          vehicle_chassis_number: row[4]?.value,
          vehicle_license_plate: row[5]?.value,
          vehicle_year: row[6]?.value,
          vehicle_purchase_price: this.convertToNumeric(row[7]?.value),
          vehicle_purchase_discount: this.convertToNumeric(row[8]?.value),
          vehicle_basic_purchase_price: dpp_beli,
          vehicle_purchase_vat: ppn_beli,
          vehicle_fixed_purchase_price: hpp_beli,
          vehicle_sales_price: this.convertToNumeric(row[9]?.value),
          vehicle_vin_number: row[10]?.value,
        });
      }
    }

    if (dataCleaned.length < 1) {
      Modal.error({ title: "Error", content: "Data Table Tidak Valid, Nilai Nominal Cannot Be NULL please fill it with numeric" });
      return;
    }

    this.setState({ submitting: true });

    const input = {
      dealer_code: currentState.dealerCode,
      company_code: currentState.companyCode,
      supplier_code: currentState.supplierCode,
      warehouse_code: currentState.warehouseCode,
      invoice_date: currentState.invoiceDate,
      invoice_number: currentState.invoiceNumber,
      delivery_date: currentState.deliveryDate,
      delivery_number: currentState.deliveryNumber,
      tax_percentage: currentState.taxPercentage,
      brand_uuid: currentState.dataOrg.copanDefaultBrandUuid,
      vehicle_condition: currentState.vehicleCondition,
      data_stock: dataCleaned,
    };

    if (dataCleaned.length > 0) {
      try {
        await stockOtodisService.setToken(this.token);
        await stockOtodisService.addMultipleStock(input).then((dataInsertStock) => {
          this.setState({ submitting: false });
          this.onReset();
          // this.onResetSheet();

          Modal.success({
            title: "Log Import Stock",
            width: 1000,
            content: (
              <div>
                <table style={{ fontSize: "83%", borderCollapse: "collapse", width: "100%" }}>
                  <thead>
                    <tr>
                      <th style={{ border: "1px solid #ddd", padding: "8px" }}>Variant&nbsp;Code</th>
                      <th style={{ border: "1px solid #ddd", padding: "8px" }}>Color&nbsp;Code</th>
                      <th style={{ border: "1px solid #ddd", padding: "8px" }}>No&nbsp;Mesin</th>
                      <th style={{ border: "1px solid #ddd", padding: "8px" }}>No&nbsp;Polisi</th>
                      <th style={{ border: "1px solid #ddd", padding: "8px" }}>Keterangan</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataInsertStock.data.data_failed.map((row: any) => {
                      return (
                        <tr key={row.orderCode}>
                          <td style={{ border: "1px solid #ddd", padding: "8px" }}>{row.vehicle_variant_code}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px" }}>{row.vehicle_color_code}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px" }}>{row.vehicle_engine_number}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px" }}>{row.vehicle_license_plate}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px", color: "red" }}>FAILED - {row.description?.toString().replace(",", "\n")}</td>
                        </tr>
                      );
                    })}
                    {dataInsertStock.data.data_success.map((row: any) => {
                      return (
                        <tr key={row.orderCode}>
                          <td style={{ border: "1px solid #ddd", padding: "8px" }}>{row.vehicle_variant_code}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px" }}>{row.vehicle_color_code}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px" }}>{row.vehicle_engine_number}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px" }}>{row.vehicle_license_plate}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px", color: "green" }}>SUCCESS</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ),
          });

          // setTimeout(function () {
          //   window.location.reload();
          // }, 2000);
        });
      } catch (e: any) {
        Modal.error({
          title: "Proses Gagal",
          content: "Server Menolak Inputan Anda :" + e.message,
        });
        await this.promisedSetState({
          submitting: false,
        });
      }
    }
  };

  convertToNumeric(inputValue: any) {
    try {
      const numericValue = inputValue.toString().replace(/[^\d]/g, "");
      const result = Number(numericValue);
      return result;
    } catch (error) {
      return Number(0);
    }
  }

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Stock`}
          breadcrumbMenu={`Import Pembelian Stock`}
          defaultSelectedKeys={["m-purchase-multiple-stock"]}
          defaultOpenKeys={["sm-stock", "sm-sm-purchase"]}
        >
          <Form layout={"vertical"}>
            <Row>
              <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Supplier <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <SupplierSelect onSupplierChangeProps={this.onSupplierChange} dealerCode={this.state.dealerCode} value={this.state.supplierCode} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Gudang <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <WarehouseSelect onWarehouseChangeProps={this.onWarehouseChange} dealerCode={this.state.dealerCode} value={this.state.warehouseCode} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Kondisi Kendaraan <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <SelectConfigArray value={this.state.vehicleCondition} onChange={(value: string) => this.onStringFieldChange("vehicleCondition", value)} dataOption={vehicleConditionList} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Persentase Pajak Beli <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="number" value={this.state.taxPercentage} placeholder="Persentase Pajak" onChange={(event) => this.onStringFieldChange("taxPercentage", event.target.value)} />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Tanggal Surat Jalan <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <DatePicker
                        value={moment(this.state.deliveryDate, "YYYY-MM-DD")}
                        format={"YYYY-MM-DD"}
                        style={{ width: "100%" }}
                        onChange={(date, dateString) => this.onStringFieldChange("deliveryDate", dateString)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Nomor Surat Jalan <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.deliveryNumber} placeholder="Nomor Surat Jalan" onChange={(event) => this.onStringFieldChange("deliveryNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Tanggal Invoice <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <DatePicker
                        value={moment(this.state.invoiceDate, "YYYY-MM-DD")}
                        format={"YYYY-MM-DD"}
                        style={{ width: "100%" }}
                        onChange={(date, dateString) => this.onStringFieldChange("invoiceDate", dateString)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Nomor Invoice <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.invoiceNumber} placeholder="Nomor Invoice" onChange={(event) => this.onStringFieldChange("invoiceNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}></Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}></Col>
                </Row>
                {/* <Divider orientation="left" plain></Divider> */}
                <br />{" "}
              </Col>

              <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <Row>
                  <Button type="primary" onClick={() => this.showModalUploadPdfVinfast(true)} style={{ margin: 5 }} loading={this.state.submitting}>
                    Upload PDF Vinfast
                  </Button>

                  <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.submitting} onClick={this.onAddStock} style={{ margin: 5 }}>
                    Simpan Data
                  </Button>

                  <Button
                    onClick={this.onResetSheet}
                    type="primary"
                    icon={<ReloadOutlined />}
                    title="Upload Tagihan"
                    className="pl-2 pr-3 mx-1 mb-2"
                    style={{ background: "#ca2e2e", borderColor: "#ca2e2e", margin: 5 }}
                    loading={this.state.submitting}
                  >
                    Refresh Table
                  </Button>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}></Col>
              <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <Spreadsheet data={this.state.dataSheet} columnLabels={this.columnLabels} onChange={this.onSheetChange} />
              </Col>
            </Row>
            <Modal
              title="Upload Invoice VinFast"
              visible={this.state.modalUploadVisible}
              onCancel={() => this.setState({ modalUploadVisible: false, modalUploadFile: null })}
              closable={false}
              maskClosable={false}
              footer={[
                <Button key="cancel" onClick={() => this.showModalUploadPdfVinfast(false)} loading={this.state.submitting}>
                  Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={this.submitPdfVinfast} loading={this.state.submitting}>
                  Process
                </Button>,
              ]}
            >
              <Form.Item>
                <i className={`text-small-grey-nopadding`}>
                  Upload Invoice PDF Vinfast <span style={{ color: "red" }}>*</span>{" "}
                </i>
                <br />
                <Upload maxCount={1} beforeUpload={this.beforeUploadFile} showUploadList={true}>
                  <Button icon={<UploadOutlined />}>Select File</Button>
                </Upload>
              </Form.Item>
            </Modal>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(ImportPucrhaseStock), 47);
